import { MatDialogRef } from '@angular/material/dialog';
import { PlantRequestModel } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class PlantItemLoad {
  public static readonly type = '[PlantItem] Load';

  constructor(public payload: string) {}
}

export class PlantItemCreate {
  public static readonly type = '[PlantItem] Create';

  constructor(public payload: PlantRequestModel) {}
}

export class PlantItemUpdate {
  public static readonly type = '[PlantItem] Update';

  constructor(public payload: PlantRequestModel) {}
}

export class PlantItemDelete {
  public static readonly type = '[PlantItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; plantId: number }) {}
}

export class PlantItemInitialState {
  public static readonly type = '[PlantItem] Set Initial State';
}
